import {
	ChangeDetectionStrategy,
	Component,
	computed,
	input,
} from '@angular/core';

@Component({
	selector: 'mar-length-counter',
	imports: [],
	standalone: true,
	template: `<p [class]="colorClass()">{{ value() }}/{{ maxLength() }}</p>`,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LengthCounterComponent {
	readonly maxLength = input<number>(5000);
	readonly value = input.required<number>();
	readonly color = input<string>('black');

	readonly colorClass = computed(() => {
		if (this.value() > this.maxLength()) return 'text-red-500';
		return `text-${this.color()}`;
	});
}
